import * as citiesRaw from "../data/cities.json";
const raw: any = citiesRaw;
const cities: any[] = Array.isArray(raw)
  ? raw
  : Array.isArray(raw && raw.default)
  ? raw.default
  : Array.isArray(Object.values(raw)[0])
  ? Object.values(raw)[0]
  : Object.values(raw);

export const IBGECode = (uf: any, city: any) => {
  const ufStr = Array.isArray(uf) ? uf[0] : uf;
  let string = Array.isArray(city) ? city[0] : city;

  if (!string) return "";
  const mapaAcentosHex = {
    a: /[\xE0-\xE6]/g,
    A: /[\xC0-\xC6]/g,
    e: /[\xE8-\xEB]/g,
    E: /[\xC8-\xCB]/g,
    i: /[\xEC-\xEF]/g,
    I: /[\xCC-\xCF]/g,
    o: /[\xF2-\xF6]/g,
    O: /[\xD2-\xD6]/g,
    u: /[\xF9-\xFC]/g,
    U: /[\xD9-\xDC]/g,
    c: /\xE7/g,
    C: /\xC7/g,
    n: /\xF1/g,
    N: /\xD1/g,
  };

  for (const letra in mapaAcentosHex) {
    const expressaoRegular = (mapaAcentosHex as any)[letra];
    string = string ? string.replace(expressaoRegular, letra).toUpperCase() : string;
  }

  const result: any = cities.find((element: any) => {
    return element.label === string && element.UF === (ufStr ? ufStr.toUpperCase() : ufStr);
  });

  return result ? result.value : "";
};

export const IBGECity = (uf: any, code: any) => {
  const ufStr = Array.isArray(uf) ? uf[0] : uf;
  const result: any = cities.find((element: any) => {
    return element.value === code && element.UF === (ufStr ? ufStr.toUpperCase() : ufStr);
  });

  return result ? result.label : "";
};
